import { FC } from "react";

const LeftArrow: FC = () => {
    return (
        <>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.60649 5.29289C9.99702 5.68341 9.99702 6.31658 9.6065 6.7071L5.31364 11H20.8994C21.4517 11 21.8994 11.4477 21.8994 12C21.8994 12.5523 21.4517 13 20.8994 13H5.31364L9.6065 17.2929C9.99702 17.6834 9.99702 18.3166 9.60649 18.7071C9.21597 19.0976 8.5828 19.0976 8.19228 18.7071L2.19233 12.7071C1.80181 12.3166 1.80181 11.6834 2.19233 11.2929L8.19228 5.2929C8.5828 4.90237 9.21597 4.90237 9.60649 5.29289Z"
                  fill="black"
                />
            </svg>
        </>
    )
}

export default LeftArrow;